import lazyLoading from './lazyLoading'
import Global from '../../../services/globalservice'

export default {
  name: 'General',
  meta: {
    icon: 'fa-tasks',
    expanded: false,
    roles: [Global.ROLE.ADMIN]
  },

  children: [
    {
      name: 'Skill',
      path: '/general/skill',
      meta: {
        roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('general/Skill')
    },
    {
      name: 'Certificate',
      path: '/general/certificate',
      meta: {
        roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('general/Certificate')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/general.js